import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";

import MaterialTable from "@material-table/core";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import ProjectService from "../../../services/ProjectService";

import { header } from'../../../shared/headerStyle';

const TOOLBAR_HEIGHT = 74;
const PAGINATION_HEIGHT = 52;
const BORDER = 1;

function ProjectObjects({projectGuid, realm, projectId}) {
    const token = useSelector((state) => state.keycloakToken);
    const [isLoading, setIsLoading] = useState(false);
    const [dataObjects, setDataObjects] = useState([]);
    const tableRef = useRef();

    const tableHeight = (window.innerHeight - TOOLBAR_HEIGHT - PAGINATION_HEIGHT - BORDER) / window.innerHeight * 100;

    const loadProjectObjects = async () => {
        try {
            setIsLoading(true);
            const result = await ProjectService.listprojectobjects(token, realm, projectId, projectGuid);
            setDataObjects(result.data);
        } catch (e) {
            console.error('Fehler beim Laden der Projektobjekte:', e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadProjectObjects();
    }, [token, realm, projectId, projectGuid]); // eslint-disable-line react-hooks/exhaustive-deps

    const getColumnType = (data) =>
        data.realestateobjectType || data.administrativeobjectType || '';

    const handleDeleteClick = async (object, event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            if (object instanceof Array) {
                await Promise.all(
                    object.map(obj => ProjectService.deleteProjectObject(token, realm, projectId, projectGuid, obj.guid))
                );
            } else {
                await ProjectService.deleteProjectObject(token, realm, projectId, projectGuid, object.guid);
            }
            await loadProjectObjects();
        } catch (e) {
            console.error('Fehler beim Entfernen des Objekts:', e);
            setIsLoading(false);
        }
    };

    return (
        <MaterialTable
            tableRef={tableRef}
            title="Zugeordnete Objekte"
            columns={[
                { title: 'Bezeichnung', field: 'name' },
                { title: 'Nummer', field: 'number' },
                { title: 'Kennzeichen', field: 'label' },
                { title: 'Typ', field: 'type', render: (rowData) => getColumnType(rowData) },
            ]}
            data={dataObjects}
            options={{
                headerStyle: header,
                rowStyle: rowData => ({
                    backgroundColor: rowData.deactivated ? '#EEE' : '#FFF'
                }),
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                actionsColumnIndex: -1,
                selection: true,
                exportButton: true,
                exportAllData: true,
                maxBodyHeight: `${tableHeight}vh`,
                minBodyHeight: `${tableHeight}vh`,
            }}
            isLoading={isLoading}
            localization={{
                pagination: {
                    labelDisplayedRows: '{from}-{to} von {count}',
                    labelRowsSelect: 'Zeilen',
                    labelRowsPerPage: 'Zeilen pro Seite'
                },
                toolbar: {
                    nRowsSelected: '{0} Zeile(n) ausgewählt',
                    searchTooltip: 'Suchen',
                    searchPlaceholder: 'Suchbegriff eingeben'
                },
                header: {
                    actions: 'entfernen'
                },
                body: {
                    emptyDataSourceMessage: 'Keine Einträge gefunden',
                    filterRow: {
                        filterTooltip: 'Filter'
                    }
                }
            }}
            onRowClick={(event, rowData) => {
                const rowDataCopy = { ...rowData };
                rowDataCopy.tableData.checked = !rowDataCopy.tableData.checked;
                const dataCopy = [...dataObjects];
                dataCopy[rowDataCopy.tableData.id] = rowDataCopy;
                setDataObjects(dataCopy);
            }}
            actions={[
                rowData => ({
                    icon: () => <DeleteOutline />,
                    tooltip: 'aus Projekt entfernen',
                    onClick: (event, rowData) => handleDeleteClick(rowData, event)
                }),
            ]}
        />
    );
}

export default ProjectObjects;
